import { marked } from 'marked'

import parseImage from './image'
import parseLink from './link'

export default function parseBox(entry) {
    const { title, content: markdownContent, type, link, illustration } = entry.fields
    const content = markdownContent ? marked.parseInline(markdownContent) : null

    return {
        title,
        content,
        type,
        link: link ? parseLink(link) : null,
        illustration: illustration ? parseImage(illustration) : null,
    }
}
